import React from 'react';

import Slider from 'react-slick';

import icon from './assets/images/icon.svg';
import PlaylistItem from './PlaylistItem';

interface PlaylistData {
  title: string;
  url?: string;
}

interface PlaylistsProps {
  items: PlaylistData[];
}

function PlaylistsContainer({ items }: PlaylistsProps) {
  const settings = {
    dots: false,
    arrows: true,
    swipeToSlide: true,
    initialSlide: 0,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1124,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: '15px',
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
        },
      },
    ],
  };

  const newItems: PlaylistData[] =
    typeof items === 'string' ? JSON.parse(items) : items;
  return (
    <div className="playlists-container">
      <Slider {...settings}>
        {newItems?.map((item, index) => (
          <PlaylistItem
            key={item?.title}
            title={item?.title}
            url={item?.url}
            icon={typeof icon === 'object' ? icon.src : icon}
            index={index}
          />
        ))}
      </Slider>
    </div>
  );
}

PlaylistsContainer.attributes = {
  items: {
    type: Array,
    default: [],
  },
  isEditing: {
    type: Boolean,
    default: false,
  },
  onItemChange: {
    type: Function,
    default: () => {},
  },
};

export default PlaylistsContainer;
